<template>
  <div class="text-center bgb">
    <h2 class="text-center">关于我们</h2>
    <span>位于国内创新前沿深圳的专业技术研发团队<br/></span>
    <span>专注于汽车领域相关软件的设计、研发、销售<br/></span>
    <span>快启动科技，让汽车更有趣！<br/><br/></span>
    <p>@深圳市快启动科技有限公司&nbsp;<br /><a href="http://beian.miit.gov.cn/" style="color:black;">粤ICP备2020122573号</a></p>
    <p><br /><br /></p>
  </div>
</template>

<script>
export default {
  name: "About",
  components: {},
  props: [],
  data() {
    return {
      baseUrl: process.env.BASE_URL,
    };
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
  watch: {},
  filters: {},
};
</script>
<style scoped>
.bgb {
background-image: url("../assets/sz.jpg");
background-repeat:no-repeat;
background-size:100%;
color: black;
}
</style>
